import { TableColumnDef } from "@app/shared/components/smart-data-grid/data-grid/data-grid.constants";
import { CommonFieldLabel, CommonFieldName } from "@app/shared/constants";

export const ImportResultDataGridColumnDef: TableColumnDef[] = [
  {
    text: CommonFieldLabel.SHEET_NAME,
    name: CommonFieldName.sheetName,
    sort: true,
    width: 5
  },
  {
    text: CommonFieldLabel.LINE_NUMBER,
    name: CommonFieldName.rowNum,
    sort: true,
    width: 5
  },
  {
    text: CommonFieldLabel.IMPORT_FAILED_MESSAGE,
    name: CommonFieldName.translationId,
    sort: true,
    width: 95
  }];

